export default {
  result: state => state.search.resultMatchesBoxes,
};
